import { computed, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private readonly activeLoaders = signal<Set<string>>(new Set());

  readonly isLoading = computed<boolean>(() => this.activeLoaders().size > 0);
  readonly isLoading$ = toObservable<boolean>(this.isLoading);

  setLoading(loaderId: string, isLoading: boolean): void {
    this.activeLoaders.update((prev) => {
      const next = new Set(prev);

      if (isLoading) {
        next.add(loaderId);
      } else {
        next.delete(loaderId);
      }

      return next;
    });
  }

  stopAllLoading(): void {
    this.activeLoaders.set(new Set());
  }

  isLoaderActive(loadingId: string): boolean {
    return this.activeLoaders().has(loadingId);
  }

  getActiveLoadersCount(): number {
    return this.activeLoaders().size;
  }
}
